export default class DtoVariousMateriel {
    constructor(obj) {
        this.id = obj.id
        this.reference = obj.reference
        this.comment = obj.comment
        this.materielType = obj.materielType
        this.purchaseDate = obj.purchaseDate
        this.warrantyTime = obj.warrantyTime
        this.manufactureDate = obj.manufactureDate
        this.withdrawalDate = obj.withdrawalDate
        this.providerId = obj.providerId
        this.serialNumber = obj.serialNumber
        this.jobExecutionId = obj.jobExecutionId
    }
}